var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartBubble = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2.25C0 1.83579 0.335786 1.5 0.75 1.5C1.16421 1.5 1.5 1.83579 1.5 2.25V19.5C1.5 20.3284 2.17157 21 3 21H23.25C23.6642 21 24 21.3358 24 21.75C24 22.1642 23.6642 22.5 23.25 22.5H3C1.5 22.5 0 21 0 19.5V2.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 13.5C9.49264 13.5 10.5 14.5074 10.5 15.75C10.5 16.9926 9.49264 18 8.25 18C7.00736 18 6 16.9926 6 15.75C6 14.5074 7.00736 13.5 8.25 13.5ZM8.25 15C7.83579 15 7.5 15.3358 7.5 15.75C7.5 16.1642 7.83579 16.5 8.25 16.5C8.66421 16.5 9 16.1642 9 15.75C9 15.3358 8.66421 15 8.25 15Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 7.5C12.4926 7.5 13.5 8.50736 13.5 9.75C13.5 10.9926 12.4926 12 11.25 12C10.0074 12 9 10.9926 9 9.75C9 8.50736 10.0074 7.5 11.25 7.5ZM11.25 9C10.8358 9 10.5 9.33579 10.5 9.75C10.5 10.1642 10.8358 10.5 11.25 10.5C11.6642 10.5 12 10.1642 12 9.75C12 9.33579 11.6642 9 11.25 9Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 12C18.1569 12 19.5 13.3431 19.5 15C19.5 16.6569 18.1569 18 16.5 18C14.8431 18 13.5 16.6569 13.5 15C13.5 13.3431 14.8431 12 16.5 12ZM16.5 13.5C15.6716 13.5 15 14.1716 15 15C15 15.8284 15.6716 16.5 16.5 16.5C17.3284 16.5 18 15.8284 18 15C18 14.1716 17.3284 13.5 16.5 13.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3ZM18 4.5C17.1716 4.5 16.5 5.17157 16.5 6C16.5 6.82843 17.1716 7.5 18 7.5C18.8284 7.5 19.5 6.82843 19.5 6C19.5 5.17157 18.8284 4.5 18 4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-bubble.f3e0f0cfdb2568d801d73f82b0654547.svg";